import { render, staticRenderFns } from "./UserDetailInfoCard.vue?vue&type=template&id=00524961&"
import script from "./UserDetailInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports